var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconForaging = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.746A9.744 9.744 0 0 1 12.746 3h.508A9.744 9.744 0 0 1 23 12.746a2.667 2.667 0 0 1-2.668 2.668H5.668A2.667 2.667 0 0 1 3 12.746zm5.254-6.229a7.679 7.679 0 0 0-3.185 6.229c0 .332.267.599.6.599h14.663c.332 0 .599-.267.599-.6 0-.517-.052-1.02-.147-1.508a2.07 2.07 0 1 1-1.634-3.41 7.674 7.674 0 0 0-4.111-2.551 3.447 3.447 0 0 1-3.414 3.931 3.457 3.457 0 0 1-3.366-2.69h-.005zm3.81 10.276-.646 3.448h3.164l-.647-3.448h2.104l.728 3.884c.078.405-.03.819-.293 1.133-.263.315-.65.5-1.06.5h-4.828a1.37 1.37 0 0 1-1.06-.5 1.37 1.37 0 0 1-.293-1.133l.724-3.884h2.108zM8.173 9.207a1.38 1.38 0 1 1 0 2.759 1.38 1.38 0 0 1 0-2.76z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconForaging, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-foraging.bc40a393.svg";
export { ForwardRef as ReactComponent };